// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.specialoffers.RentalManagerUserPropertySpecialOfferWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import {
  RentalManagerUserPropertySpecialOfferWebApiHandler_create,
  RentalManagerUserPropertySpecialOfferWebApiHandler_delete,
  RentalManagerUserPropertySpecialOfferWebApiHandler_update,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  ListingAlias,
  RentalManagerSpecialOfferInputsDto,
  UserPropertyDetailsSpecialOfferDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface DeleteParams {
  listingAlias: ListingAlias;
  offerIdEncoded: string;
}

export interface RentalManagerUserPropertySpecialOfferWebApiHandler_create_Args {
  postData: RentalManagerSpecialOfferInputsDto;
}

export type RentalManagerUserPropertySpecialOfferWebApiHandler_create_Options = UseMutationOptions<
  UserPropertyDetailsSpecialOfferDto,
  unknown,
  RentalManagerUserPropertySpecialOfferWebApiHandler_create_Args
>;

/**
 * Create a special offer for a property
 */
export const useRentalManagerUserPropertySpecialOfferWebApiHandler_create = (
  options: Omit<RentalManagerUserPropertySpecialOfferWebApiHandler_create_Options, 'mutationFn'> = {},
) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpecialOfferWebApiHandler_create_Args) =>
      RentalManagerUserPropertySpecialOfferWebApiHandler_create(args.postData),
  });
};

export interface RentalManagerUserPropertySpecialOfferWebApiHandler_delete_Args {
  getParams: DeleteParams;
}

export type RentalManagerUserPropertySpecialOfferWebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpecialOfferWebApiHandler_delete_Args
>;

/**
 * Delete a listing special offer
 */
export const useRentalManagerUserPropertySpecialOfferWebApiHandler_delete = (
  options: Omit<RentalManagerUserPropertySpecialOfferWebApiHandler_delete_Options, 'mutationFn'> = {},
) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpecialOfferWebApiHandler_delete_Args) =>
      RentalManagerUserPropertySpecialOfferWebApiHandler_delete(args.getParams),
  });
};

export interface RentalManagerUserPropertySpecialOfferWebApiHandler_update_Args {
  postData: RentalManagerSpecialOfferInputsDto;
}

export type RentalManagerUserPropertySpecialOfferWebApiHandler_update_Options = UseMutationOptions<
  UserPropertyDetailsSpecialOfferDto,
  unknown,
  RentalManagerUserPropertySpecialOfferWebApiHandler_update_Args
>;

/**
 * Update a special offer of a property
 */
export const useRentalManagerUserPropertySpecialOfferWebApiHandler_update = (
  options: Omit<RentalManagerUserPropertySpecialOfferWebApiHandler_update_Options, 'mutationFn'> = {},
) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpecialOfferWebApiHandler_update_Args) =>
      RentalManagerUserPropertySpecialOfferWebApiHandler_update(args.postData),
  });
};
